export const tableColumns = [
  { name: 'row_num', title: '#', getCellValue: row => row.row_num, isNumber: true },
  { name: 'actions', title: 'Actions', getCellValue: row => row },
  { name: 'created_at', title: 'Created At', getCellValue: row => row.created_at },
  { name: 'updated_at', title: 'Updated At', getCellValue: row => row.updated_at },
  { name: 'name', title: 'Name', getCellValue: row => row.name },
  { name: 'file_size', title: 'File Size', getCellValue: row => row.file_size, isNumber: true },
  { name: 'com_brand', title: 'Com Brand', getCellValue: row => row.com_brand },
  { name: 'folder', title: 'Folder', getCellValue: row => row.folder },
  { name: 'description', title: 'Description', getCellValue: row => row.description },
  { name: 'language', title: 'Language', getCellValue: row => row.language },
  { name: 'first_page', title: 'First Page', getCellValue: row => row.first_page, isNumber: true },
];

export const tableColumnWidths = [
  { columnName: 'row_num', width: 60 },
  { columnName: 'actions', width: 120 },
  { columnName: 'created_at', width: 120 },
  { columnName: 'updated_at', width: 120 },
  { columnName: 'name', width: 450 },
  { columnName: 'file_size', width: 100 },
  { columnName: 'com_brand', width: 80 },
  { columnName: 'folder', width: 300 },
  { columnName: 'description', width: 400 },
  { columnName: 'language', width: 120 },
  { columnName: 'first_page', width: 100 },
];

export const tableColumnExtensions = [
  { columnName: 'row_num', align: 'right' },
  { columnName: 'file_size', align: 'right' },
  { columnName: 'created_at', align: 'right' },
  { columnName: 'updated_at', align: 'right' },
];

export const tableFilteringStateColumnExtensions = [
  { columnName: 'row_num', filteringEnabled: false },
  { columnName: 'actions', filteringEnabled: false },
  { columnName: 'created_at', filteringEnabled: false },
  { columnName: 'updated_at', filteringEnabled: false },
  { columnName: 'first_page', filteringEnabled: false },
];

export const tableSortingStateColumnExtensions = [
  { columnName: 'row_num', sortingEnabled: false },
  { columnName: 'actions', sortingEnabled: false },
  { columnName: 'created_at', sortingEnabled: true },
  { columnName: 'updated_at', sortingEnabled: true },
  { columnName: 'name', sortingEnabled: true },
  { columnName: 'file_size', sortingEnabled: true },
  { columnName: 'com_brand', sortingEnabled: false },
  { columnName: 'folder', sortingEnabled: true },
  { columnName: 'description', sortingEnabled: false },
  { columnName: 'language', sortingEnabled: false },
  { columnName: 'first_page', sortingEnabled: true },
];
